import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import JobMain from "./JobMain";
import { useJobs } from "../../hooks/useJobs";

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const { data } = useJobs({ status: "active" });

  useEffect(() => {
    document.title = "Jobs | Society of Aquaculture Professionals";
  }, []);

  useEffect(() => {
    if (data?.data?.items?.length > 0) {
      setJobs(data.data.items);
    }
  }, [data]);

  return (
    <>
      <Header />
      <JobMain jobs={jobs} />
      <Footer />
    </>
  );
};

export default Jobs;
